export const IDIOMAS_LABELS = Object.freeze({
  en: "Inglês",
  es: "Espanhol",
  "pt-pt": "Português (Portugal)",
});
